import {Component, Input} from '@angular/core';
import {ThingActivatorsInterface} from '@app/app/shared/interfaces/thing/thing-activator.interface';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';

@Component({
  templateUrl: './park-activator-logic-control.html',
  selector: 'park-activator-logic-control'
})

export class ParkActivatorLogicControlComponent {
  @Input() public activator: ThingActivatorsInterface;
  @Input() public activatorId: string;
  @Input() public parkId: string;
  @Input() public id: string;

  private MODE_AUTO = 'auto';
  private MODE_MANUAL = 'manu';
  private MODE_OFF = 'off';

  public values(obj: object) {
    return Object.values(obj);
  }

  public isAuto() {
    return (this.activator.md === this.MODE_AUTO);
  }

  public isManual() {
    return (this.activator.md === this.MODE_MANUAL);
  }

  public isOff() {
    return (this.activator.md === this.MODE_OFF);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/controls/features/activators-logic/control/park-activator-logic-control.component.ts